import React, {createContext, useState} from "react";
import PropTypes from "prop-types";


const RouteProvider = ({children}) => {

    const [isPrivateRoute, setPrivateRoute] = useState();

    return (
        <RouteContext.Provider value={{ isPrivateRoute, setPrivateRoute }}>
            {children}
        </RouteContext.Provider>
    );
};

RouteProvider.propTypes = {
    children: PropTypes.any
};


export const RouteContext = createContext();
export default RouteProvider;
